import React from "react";
import momentTimezone from "moment-timezone";
import ReactTooltip from "react-tooltip";

const GeneratedTooltip = ({ children, index, id }) => {
  return (
    <>
      <span data-tip data-for={`${id}${index}`}>
        {children}
      </span>
      {children && (
        <ReactTooltip type="dark" effect="solid" id={`${id}${index}`}>
          {children}
        </ReactTooltip>
      )}
    </>
  );
};

const getColumns = () => {
  return [
    {
      Header: "Registration Number",
      id: "registrationNumber",
      minWidth: 170,
      maxWidth: 180,
      accessor: (d) => d.registrationNumber,
      Cell: ({ value, row: { index }, column: { id } }) => (
        <GeneratedTooltip index={index} id={id}>
          {value}
        </GeneratedTooltip>
      ),
    },
    {
      Header: "Employer Name",
      id: "sort_empBusinessName",
      minWidth: 175,
      accessor: (d) => d.empBusinessName,
      Cell: ({ value, row: { index }, column: { id } }) => (
        <GeneratedTooltip index={index} id={id}>
          {value}
        </GeneratedTooltip>
      ),
    },
    {
      Header: "FEIN",
      id: "empFein",
      minWidth: 100,
      maxWidth: 110,
      accessor: (d) => d.empFein,
      Cell: ({ value, row: { index }, column: { id } }) => (
        <GeneratedTooltip index={index} id={id}>
          {value}
        </GeneratedTooltip>
      ),
    },
    {
      Header: "Job Title",
      id: "sort_jobTitle",
      minWidth: 175,
      accessor: (d) => d.jobTitle,
      Cell: ({ value, row: { index }, column: { id } }) => (
        <GeneratedTooltip index={index} id={id}>
          {value}
        </GeneratedTooltip>
      ),
    },
    {
      Header: "Workers",
      id: "numberOfWorkers",
      minWidth: 80,
      maxWidth: 90,
      accessor: (d) => d.numberOfWorkers,
      Cell: ({ value, row: { index }, column: { id } }) => (
        <GeneratedTooltip index={index} id={id}>
          {value}
        </GeneratedTooltip>
      ),
    },
    {
      Header: "Valid From",
      id: "validityStartDate",
      width: 140,
      accessor: (d) => d.validityStartDate,
      Cell: ({ value, row: { index }, column: { id } }) => {
        const _date = value
          ? momentTimezone(Number(value))
              .tz("America/New_York")
              .format("MMMM D, YYYY")
          : "";
        return (
          <GeneratedTooltip index={index} id={id}>
            {_date}
          </GeneratedTooltip>
        );
      },
    },
    {
      Header: "Valid To",
      id: "validityEndDate",
      accessor: (d) => d.validityEndDate,
      Cell: ({ value, row: { index }, column: { id } }) => {
        const _date = value
          ? momentTimezone(Number(value))
              .tz("America/New_York")
              .format("MMMM D, YYYY")
          : "";
        return (
          <GeneratedTooltip index={index} id={id}>
            {_date}
          </GeneratedTooltip>
        );
      },
    },
  ];
};

export default getColumns;
